import { Injectable, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { schoolIdFromRoute } from './route-school-id';
import { isCalculatorShell, showsFooter } from './route-shell';

/**
 * App shell layout derived from the router (route data + schoolId),
 * so AppComponent stays a thin view over these signals.
 */
@Injectable({ providedIn: 'root' })
export class ShellLayoutService {
  private readonly router = inject(Router);

  /** Calculator chrome: stage nav + panel frame. */
  readonly insideApp = signal(false);
  /** Disclaimer footer (Welcome + results). */
  readonly showFooter = signal(false);
  /** Aid Quiz product copy (schoolId aidquiz). */
  readonly isAidQuiz = signal(false);

  constructor() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    ).subscribe(event => this.onNavigationEnd(event));
  }

  private onNavigationEnd(event: NavigationEnd) {
    document.body.scrollTop = 0;
    this.trackPageView(event.urlAfterRedirects);

    const root = this.router.routerState.snapshot.root;
    this.insideApp.set(isCalculatorShell(root));
    this.showFooter.set(showsFooter(root));

    const schoolId = schoolIdFromRoute(root);
    this.isAidQuiz.set(schoolId === 'aidquiz');
  }

  private trackPageView(pagePath: string) {
    if (!environment.production) {
      return;
    }
    try {
      gtag('config', 'UA-114912870-1', { page_path: pagePath });
    } catch (err) {
      console.log(err);
    }
  }
}
